import { AxiosInstance } from "axios";
import { AttachmentDetail } from "interfaces/attachment";

export const getAttachment = async (
  axiosInstance: AxiosInstance,
  id?: number | null | undefined,
  signal?: AbortSignal
): Promise<AttachmentDetail> => {
  if (!id) {
    throw new Error("`id` is required");
  }

  const response = await axiosInstance.get<AttachmentDetail>(
    `attachments/${id}`,
    { signal }
  );
  return response.data;
};

export const getAttachmentsByCaseId = async (
  axiosInstance: AxiosInstance,
  id?: number | null | undefined,
  signal?: AbortSignal
): Promise<AttachmentDetail[]> => {
  if (!id) {
    throw new Error("`id` is required");
  }

  const response = await axiosInstance.get<AttachmentDetail[]>(
    `/events/${id}/attachments`,
    { signal }
  );
  return response.data;
};
